import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { json, useNavigate } from "react-router-dom";
import { ForeignData_API } from "../../../../APIs/ForeignData.api";
import RenderInputsPXK from "../renderInput";

export default function CreatePhieuXuatKho() {
  const {
    lang,
    pages,
    proxy,
    functions,
    database: { fields, tables },
  } = useSelector((state) => state);

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    getValues,
    reset,
    control,
    formState: { errors },
  } = useForm();
  const [refresh, setRefresh] = useState(false);
  const [defaultValues, setDefaultValues] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [isTables, setTables] = useState([]);
  const [options, setOptions] = useState({});

  const [inputFields, setInputFields] = useState([
    {
      name: "Mã Phiếu Xuất (ERP)",
      alias: "10MPXK",
      type: "text",
      required: true,
    },
    // {
    //   name: "Lệnh đóng bao",
    //   alias: "2MLĐB",
    //   type: "select",
    //   required: true,
    //   table_id: 22587,
    //   displayFields: ["1MLĐB", "23MSP", "2SCSX"],
    //   isPK: "1MLĐB",
    //   dataFromLDB: [
    //     {
    //       key: "2SCSX",
    //       alias: "1SLN",
    //       value: "2SCSX",
    //     },
    //     {
    //       key: "SanPham",
    //       alias: "24MSP",
    //       label: ["22MSP", "10TSP"],
    //       value: "22MSP",
    //     },
    //     // {
    //     //   key: "ToChuc",
    //     //   alias: "maToChuc",
    //     //   label: ["2MLK", "7LK"],
    //     //   value: "2MLK",
    //     // },
    //     {
    //       key: "Kho",
    //       alias: "13MK",
    //       label: ["maKhoERPKho", "4TK", "8LK"],
    //       value: "11MK",
    //     },
    //     {
    //       key: "KhuVuc",
    //       alias: "maKhuVuc",
    //       label: ["7MKV", "2TKV"],
    //       value: "7MKV",
    //     },
    //   ],
    // },
    {
      name: "Ngày Xuất",
      alias: "6NXH",
      type: "datetime-local",
    },
    {
      name: "Tên Phương Tiện",
      alias: "4PT",
      type: "text",
    },
    {
      name: "STT Xe/Ghe",
      alias: "1SPT",
      type: "text",
    },
    {
      name: "Biển Số Xe/Tàu",
      alias: "1BSPT",
      type: "text",
    },
    {
      name: "Chủ Xe/Tàu",
      alias: "1CPT",
      type: "text",
    },
    {
      name: "Đại Diện Bốc Xếp",
      alias: "2ĐDBX",
      type: "text",
    },
    {
      name: "Người Nhận",
      alias: "10NN",
      type: "text",
    },
    {
      name: "Lý Do Xuất (nếu có trường hợp bán hàng chuyển chủ)",
      alias: "lyDoXuatPXK",
      type: "text",
    },
    {
      name: "LXH/LĐĐNB",
      alias: "2LGH",
      type: "select",
      table_id: 22577,
      displayFields: ["2MLXH", "5SLCXTT", "28MSP"],
      required: true,
      isPK: "2MLXH",
      isMulti: true,
      isApi: "/api/PXK/optionLGH",
      isButton: { state: true, text: "Thêm" },
      isModal: {
        id: "CreatePhieuXuatKho",
        isOpen: false,
        text: "add",
        fields: [
          {
            name: "LXH/LĐĐNB",
            alias: "LGH",
            type: "select",
            table_id: 22577,
            displayFields: ["2MLXH", "5SLCXTT", "28MSP"],
            required: true,
            isPK: "2MLXH",
            isApi: "/api/PXK/optionLGH",
            readOnly: true,
          },
          {
            name: "Số Lượng Tấn Cần Xuất",
            alias: "2",
            type: "float",
            isParamSuggest: true,
          },
          {
            name: "Gợi Ý Lệnh Đóng Bao",
            alias: "3",
            type: "select",
            // table_id: 22587,
            isSuggest: true,
            displayFields: ["1MLĐB"],
            isPK: "1MLĐB",
            isApi: "/api/PXK/optionLDB",
            isMulti: true,
            isButton: {
              state: true,
              text: "Gợi ý",
              click: false,
            },
            isTable: {
              state: true,
              headers: [
                { label: "Mã Lệnh Đóng Bao", alias: "3MLĐB" },
                { label: "Mã Thành Phẩm", alias: "SP" },
                { label: "Số Lot", alias: "SoLot" },
                {
                  label: "SL Cần Xuất",
                  alias: "SLX",
                  color: "rgb(25, 14, 185)",
                },
                {
                  label: "SL Đóng Bao Chưa Xuất",
                  alias: "SLCX",
                  color: "rgb(0, 171, 65)",
                },
              ],
            },
          },
          {
            name: "Ghi Chú",
            alias: "4",
            type: "textarea",
          },
        ],
      },
      isTable: {
        state: true,
        headers: [
          { label: "LXH/LĐĐNB", alias: "2MLXH" },
          { label: "Mã Thành Phẩm", alias: "SanPham" },
          { label: "SL Tấn Còn Lại", alias: "TanConLai" },
          { label: "Số Lượng Tấn Cần Xuất", alias: "4SLCXTT", type: "number" },
          {
            label: "Gợi Ý Lệnh Đóng Bao",
            alias: "3MLĐB",
            type: "text",
            readOnly: true,
          },
          { label: "Ghi Chú", alias: "2GCS", type: "text" },
        ],
      },
    },
  ]);
  const _token = localStorage.getItem("_token");
  const [slCanXuat, lenhGiaoHang] = watch(["4SLCXTT", "2LGH"]);
  const [dataSuggest, setDataSuggest] = useState({});
  const [showDataSuggest, setShowDataSuggest] = useState(false);
  const lichDongBao = getValues("3MLĐB");
  console.log("dataSuggest", dataSuggest);
  // useEffect(() => {
  //   if (lenhGiaoHang) {
  //     fetch(`${proxy()}/api/PXK/inforLGH`, {
  //       method: "POST",
  //       headers: {
  //         Authorization: _token,
  //         "content-type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         msp: dataSuggest?.["2LGH"]?.map((item) => item["25MSP"]),
  //       }),
  //     })
  //       .then((res) => res.json())
  //       .then((res) => {
  //         setDataSuggest((prev) => {
  //           return {
  //             ...prev,
  //             "2LGH": prev["2LGH"]?.map((item, index) => {
  //               const newData = res?.data.find(({_id})=> _id === item?._id);
  //               console.log("itemitem", item?._id)
  //               return {
  //                 ...item,
  //                 ...newData,
  //                 SanPham: `${item?.["25MSP"]}\n${newData?.sanPham}`,
  //               };
  //             }),
  //           };
  //         });

  //         setShowDataSuggest(true);
  //       });
  //   }
  // }, [lenhGiaoHang]);

  useEffect(() => {
    fetch(`${proxy()}/api/PXK/ldb/${slCanXuat}`, {
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setDataSuggest((prev) => {
          return {
            ...prev,
            "3MLDB": res,
          };
        });
        console.log("lichDongBao", lichDongBao);
        if (lichDongBao) {
          setShowDataSuggest(false);
        } else {
          setShowDataSuggest(true);
        }
      });
  }, [slCanXuat, lichDongBao]);
  //   useEffect(() => {
  //     fetch(proxy() + `/api/PNK/search`, {
  //       method: "POST",
  //       headers: {
  //         Authorization: _token,
  //         "content-type": "application/json",
  //       },
  //     })
  //       .then((res) => res.json())
  //       .then((res) => {
  //         const { success, data } = res;
  //         if (success) {
  //           if (lichDongBao || maKho) {
  //             const field = inputFields.find(
  //               ({ dataFromLDB = [] }) => dataFromLDB?.length
  //             );
  //             if (field) {
  //               field?.dataFromLDB?.forEach((item) => {
  //                 const { key, value, alias, label = [], items = [] } = item;

  //                 if (label.length) {
  //                   const mappedLabel = label
  //                     .map((lb) => data?.[key]?.[lb])
  //                     .filter(Boolean)
  //                     .join(field?.betChar || "|");
  //                   setValue(alias, data?.[key]?.[value]);
  //                   setSelectedValues((prev) => {
  //                     const newPrev = { ...prev };
  //                     newPrev[alias] = {
  //                       label: mappedLabel ?? "",
  //                       value: data[key]?.[value],
  //                     };
  //                     return newPrev;
  //                   });
  //                 } else {
  //                   setValue(alias, data[key]);
  //                 }
  //               });
  //             }
  //           } else {
  //             setValue("2SPN", data);
  //           }
  //         }
  //       });
  //   }, [refresh]);
  // useEffect(() => {
  //   fetch(proxy() + "/api/PNK", {
  //     headers: {
  //       Authorization: _token,
  //       "content-type": "application/json",
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((res) => {
  //       const { success, data } = res;
  //       if (success) {
  //         setValue("2SPN", data);
  //       }
  //     });
  // }, []);

  useEffect(() => {
    const tableId = 1320787;
    const api_id = [];

    pages
      .filter(({ is_hidden }) => !is_hidden)
      .forEach((page) => {
        page.children
          .filter(({ is_hidden }) => !is_hidden)
          .forEach((child) => {
            child.component.forEach((item) => {
              const { props } = item;
              const findId = props.source?.tables?.find(
                (item) => item.id === tableId
              );
              if (findId) {
                const currentPage = pages.find((p) => p.block === item.id)
                  ?.component?.[0]?.children;

                if (currentPage) {
                  const mappedFields = currentPage
                    .map((item) => {
                      const {
                        props: {
                          variable_name,
                          title: { content, visible },
                          required,
                          displayField,
                          betChar,
                        },
                      } = item;
                      if (!visible) return null;

                      const field = inputFields.find(
                        ({ alias }) => alias === variable_name
                      );

                      if (field) {
                        return {
                          ...field,
                          name: content,
                          alias: variable_name,
                          required,
                          betChar,
                          displayFields:
                            displayField && displayField.length
                              ? displayField?.map(({ value }) => value)
                              : field.displayFields,
                        };
                      }
                    })
                    .filter(Boolean);
                  setInputFields(mappedFields);
                }
                setTables(findId);
                api_id.push(props?.buttons?.add?.api?.api_id);
              }
            });
          });
      });

    fetch(`${proxy()}/apis/api/${api_id?.[0]}/input_info`, {
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { data } = res;
        if (data) {
          setDefaultValues(data.display_fields);
          data.display_fields.forEach((item) => {
            if (inputFields.some(({ alias }) => item.fomular_alias === alias)) {
              const { default_value, fomular_alias } = item;
              if (default_value) {
                // setValue(fomular_alias, item.default_value);
              }
            }
          });
        }
      });
  }, [pages]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        for (const item of inputFields) {
          if (item.type === "input-select") {
            const table_id = item?.table_id;
            const foreignResponse = await ForeignData_API.get(proxy(), _token, {
              table_id,
            });
            const { data: foreignData = [] } = foreignResponse;

            if (foreignData.length) {
              const mapped = foreignData.reduce((acc, curr) => {
                const fields = item?.displayFields?.map((field) => curr[field]);

                if (fields.some((field) => field)) {
                  acc.push({
                    label: fields.join("|"),
                    value: fields?.[0],
                  });
                }
                return acc;
              }, []);
              setOptions(mapped);
            }
          }

          // setOptions((prev) => ({ ...prev, ...selectedValuesTemp }));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [inputFields, _token]);

  const onSubmit = async (data) => {
    const mappedData = {
      data: {
        ...data,
        PP: dataSuggest["2LGH"],
      },
      default_field_value: defaultValues,
      table: isTables,
    };

    console.log("mappedData", mappedData);
    // const res = await submitForm({
    //   url: `/api/PNK`,
    //   data: mappedData,
    //   proxy,
    //   lang,
    //   inputFields,
    // });
    // if (res) {
    //   inputFields.forEach((item) => {
    //     const { alias, readOnly } = item;
    //     if (!readOnly) {
    //       reset({
    //         [alias]: "",
    //       });
    //     }
    //   });
    //   setRefresh(true);
    //   setSelectedValues({});
    // }
  };

  return (
    <>
      <form className="midd_cont" onSubmit={handleSubmit(onSubmit)}>
        <div className="container-fluid">
          <div className="row column_title">
            <div className="col-md-12">
              <div className="page_title">
                <h4 className="ml-1">Quản Lý Dữ Liệu</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="white_shd full margin_bottom_30 mb-0">
                <div className="full graph_head_cus d-flex">
                  <div className="heading1_cus margin_0 ">
                    <h5>
                      <label className="pointer" onClick={() => navigate(-1)}>
                        <a title={lang["back"]}>
                          <i className=" fa fa-chevron-circle-left mr-1 mt-3 mb-0 nav-item nav-link" />
                        </a>
                        Phiếu Xuất Kho
                        <i className="fa fa-chevron-right ml-2 mr-1" />
                        {lang["create"]}
                      </label>
                    </h5>
                  </div>
                </div>
                <div className="table_section padding_infor_info input_put">
                  <div className="col-md-12">
                    <div className="row w-50-pct mg-auto p-1 bg-white input-put">
                      {inputFields.map((field, index) => {
                        const {
                          required,
                          name,
                          alias,
                          type,
                          col,
                          readOnly = false,
                          table_id,
                          displayFields,
                          style,
                        } = field;
                        return (
                          <>
                            <div
                              className={` ${
                                col ? col : `col-sm-8  offset-sm-2`
                              } mb-3`}
                              {...register(alias)}
                              style={style}
                            >
                              <label class="form-label">
                                {name}
                                {required && (
                                  <span style={{ color: "red" }}>*</span>
                                )}
                              </label>
                              <RenderInputsPXK
                                control={control}
                                register={register}
                                selectedValues={selectedValues}
                                setSelectedValues={setSelectedValues}
                                field={field}
                                options={options}
                                setValue={setValue}
                                getValues={getValues}
                                refresh={refresh}
                                watch={watch}
                                dataSuggest={dataSuggest}
                                setDataSuggest={setDataSuggest}
                                showDataSuggest={showDataSuggest}
                                setShowDataSuggest={setShowDataSuggest}
                              />
                            </div>
                          </>
                        );
                      })}
                      <div className="col-sm-7 offset-sm-3 p-0">
                        <div className="d-flex justify-content-end">
                          <button
                            type="submit"
                            className="btn btn-success mr-2"
                            style={{
                              minWidth: "105px",
                            }}
                            // onClick={() => setSubmit(true)}
                          >
                            Thêm mới
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger"
                            style={{
                              minWidth: "105px",
                            }}
                            onClick={() => navigate(-1)}
                          >
                            Đóng
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}
